import React from 'react';
import { Card, CardContent, Typography, Box, Chip, Divider } from '@mui/material';

export const MiniCardResumenEmpleadosModal = ({
  title,
  count,
  icon,
  colorBgIcon,
  totalText,
  colorTitle,
  bgTitle,
  activos,
  inactivos,
  totalUsuarios,
  withQuantity,
  onOpenModal,
  modalType,
}: any) => {
  const openModal = () => {
    if (typeof onOpenModal === 'function') {
      onOpenModal(modalType);
    }
  };

  return (
    <Card
      onClick={openModal}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        p: 2,
        borderRadius: 3,
        boxShadow: 4,
        bgcolor: 'background.paper',
        maxWidth: 340,
        cursor: 'pointer',
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <CardContent sx={{ p: 0, '&:last-child': { paddingBottom: 0 } }}>
          <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>
            <Chip
              size="small"
              label={title}
              sx={{
                color: colorTitle,
                background: bgTitle,
                fontWeight: 700,
                fontSize: '0.75rem',
              }}
            />
          </Typography>

          <Typography
            variant="h4"
            color="text.primary"
            sx={{
              fontWeight: 600,
              fontSize: '2rem',
              lineHeight: 1.2,
              textAlign: 'center',
              backgroundColor: '#663CC114',
              borderRadius: 20,
            }}
          >
            {count}
          </Typography>

          <Divider sx={{ my: 2 }} />
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{
              fontWeight: 500,
              fontSize: '0.875rem',
              mt: 0.5,
              letterSpacing: 0.5,
            }}
          >
            👥 {totalText}
          </Typography>
        </CardContent>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            p: 1.5,
            borderRadius: 2,
            bgcolor: colorBgIcon,
            color: 'primary.contrastText',
            ml: 2,
            width: 50,
            height: 50,
          }}
        >
          {icon}
        </Box>
      </Box>

      <Box sx={{ mt: 2, minHeight: 30 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 2 }}>
          {withQuantity && (
            <>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 110 }}>
                <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: 'success.main' }} />
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  Activos: <strong>{activos}</strong>
                </Typography>
              </Box>

              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 120 }}>
                <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: 'error.main' }} />
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  Inactivos: <strong>{inactivos}</strong>
                </Typography>
              </Box>
            </>
          )}
        </Box>
      </Box>
    </Card>
  );
};
